export default __webpack_public_path__ + "static/media/featured7.f8d554e5.png";